import IconCatch from '@/components/icons/icon-catch/icon-catch';
import useIsMobile from '@/hooks/use-is-mobile';
import { Flex, Text } from '@cmpsr/components';
import AddNewActionLink from '../../../common/add-new-action-link';

export default function CurrentActionPlanEmptyState() {
  const isMobile = useIsMobile();

  return (
    <Flex
      flexDir="column"
      alignItems="center"
      textAlign="center"
      bgColor="primary-default"
      borderRadius="radii-3"
      border="1px solid"
      borderColor="ui-element-divider"
      px={{ base: 'spacer-4', lg: 'spacer-12' }}
      py={{ base: 'spacer-5', lg: 'spacer-14' }}
      gap="spacer-8"
      flexGrow={1}
    >
      <IconCatch
        icon="task-list-edit"
        backgroundColor="primary-hover"
        borderRadius="10px"
        size={isMobile ? 'l' : 'xl'}
        alt="Task List icon"
      />
      <Text variant="text-header-2XL" color="text-light">
        Congrats, you have{' '}
        <Text as="span" textStyle="text-header-2xl-v" color="text-light">
          completed{' '}
        </Text>
        all your action items
      </Text>
      <AddNewActionLink variant="responsiveLg" />
    </Flex>
  );
}
